import { ReactNode } from 'react';
import { useSnapshot } from 'valtio';

import GenericLoader, { LoadingState } from '@cartwhl/ui/feature/GenericLoader';
import useMediaQuery from '@cartwhl/ui/hooks/useMediaQuery';
import { PANEL_WIDTH } from '@cartwhl/ui/layout/Panel';

import { uiStore } from 'stores';

import Header from './Header';
import HotkeyInfo from './HotkeyInfo';
import PanelButtons from './PanelButtons';
import Panels from './Panels';
import './StudioLayout.css';

export default function StudioLayout({
  player,
  prompInput,
  cameraButtons,
  footer,
  overlays,
  loadingState,
}: {
  player: ReactNode;
  prompInput: ReactNode;
  cameraButtons: ReactNode;
  footer?: ReactNode;
  overlays?: ReactNode;
  loadingState?: LoadingState;
}) {
  const { openPanel } = useSnapshot(uiStore.state);
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <>
      <div className="flex h-screen w-full overflow-hidden">
        <div
          className="flex h-full flex-col transition-[width] duration-200"
          style={{
            width:
              openPanel && isDesktop ? `calc(100% - ${PANEL_WIDTH}px)` : '100%',
          }}
        >
          <Header />
          <div
            className={`flex min-h-0 w-full flex-1 flex-col transition-[padding] duration-200 ${
              openPanel ? 'sm:px-5 lg:pr-0' : 'sm:px-5'
            }`}
          >
            <div className="relative z-0 min-h-0 flex-1">
              <div className="absolute inset-2 sm:inset-4">
                {overlays}
                {loadingState && <GenericLoader loadingState={loadingState} />}
              </div>
              <div className="h-full w-full overflow-hidden rounded-3xl">
                <div className="flex h-full w-full justify-center">
                  <div className="w-full sm:w-[calc(100vw-40px)]">{player}</div>
                </div>
              </div>
              <div className="studio-layout pointer-events-none absolute inset-2 sm:inset-4">
                <div className="flex items-end justify-start [grid-area:camera-buttons]">
                  {cameraButtons}
                </div>
                <div className="flex items-end justify-end [grid-area:panel-buttons]">
                  <PanelButtons
                    openPanel={openPanel}
                    setOpenPanel={uiStore.setOpenPanel}
                  />
                </div>
                <div className="relative flex w-full min-w-0 flex-col items-stretch justify-center [grid-area:front-door] md:order-2 md:flex-1">
                  {prompInput}
                </div>
              </div>
            </div>

            <div>{footer}</div>
          </div>
        </div>
        <Panels />
      </div>
      <HotkeyInfo />
    </>
  );
}
